import { Injectable } from '@angular/core';
import { BaseService } from '@common-modules/shared/base.service';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class CTSyncMapGridService extends BaseService {
  private gridSelectedElementsSubject = new BehaviorSubject<any[]>([]);
  gridSelectedElements$ = this.gridSelectedElementsSubject.asObservable();

  private syncGridMapSubject = new BehaviorSubject<boolean>(false);
  syncGridMap$ = this.syncGridMapSubject.asObservable();

  setGridElements(elements: any[]): void {
    if (this.syncGridMapSubject.value) {
      this.gridSelectedElementsSubject.next(elements);
    }
  }

  setSyncGridMap(isUnlocked: boolean): void {
    this.syncGridMapSubject.next(isUnlocked);
  }
}
